module.exports = __webpack_public_path__ + "img/profile_pic_boy.5bb17341.jpg";